// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bVBR","select":"styles_select__SjUyj"};